import { Button, ButtonProps } from "antd";
import classNames from "classnames";
import styles from "./style.module.scss";
import { forwardRef, ReactNode } from "react";
import VLTooltip from "../../VLTooltip";
import { ButtonType } from "antd/es/button/buttonHelpers";

type VLButtonPropsBase = Omit<ButtonProps, "type"> & {
  tooltip?: ReactNode;
  text?: string;
};

export type VLPrimaryButtonProps = VLButtonPropsBase & {
  type: "primary";
  isGradient?: boolean;
};
export type VLNormalButtonProps = VLButtonPropsBase & {
  type: Exclude<ButtonType, "primary"> | "secondary";
};

export type VLButtonProps = VLNormalButtonProps | VLPrimaryButtonProps;

const VLButton = forwardRef<HTMLButtonElement, VLButtonProps>(
  ({ tooltip, className, size = "large", ...rest }, ref) => {
    const btnClassName = classNames(styles.vlButton, className, {
      [styles.gradient]: rest.type === "primary" && rest.isGradient,
      [styles.secondary]: rest.type === "secondary",
    });
    const type = rest.type === "secondary" ? "default" : rest.type;
    return (
      <VLTooltip title={tooltip}>
        <Button
          ref={ref}
          className={btnClassName}
          size={size}
          {...rest}
          type={type}
        >
          {rest.text || rest.children}
        </Button>
      </VLTooltip>
    );
  },
);

export default VLButton;
